export enum MenuType {
    User = 'User Menu',
    Admin = 'Admin Menu'
}
